export const POSTCODES_BASE_URL = "https://api.postcodes.io/postcodes";
export const POSTCODES_ENDPOINT = "/autocomplete";
export const DISTANCE_OPTIONS = [10, 20, 30, 40, 50];
